<i18n>
{
  "fr": {
    "modal_submit_button": {
      "button": "Continuer"
    }
  }
}
</i18n>
<template>
  <div class="modal-submit-button__submit-wrapper">
    <component
      :is="redirectUrl ? 'a' : 'button'"
      :href="redirectUrl"
      :class="className"
      :disabled="disabled"
      @click="click"
    >
      {{ submitButtonLabel }}
    </component>
  </div>
</template>

<script>
export default {
  name: 'ModalSubmitButton',
  props: {
    withIcon: {
      type: Boolean,
      default: true,
    },
    redirectUrl: {
      type: String,
      default: undefined,
    },
    submitButtonLabel: {
      type: String,
      default: function () {
        return this.$t('modal_submit_button.button');
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    className() {
      return {
        [`modal-submit-button__submit base-btn base-btn--secondary base-btn--after-icon`]: true,
        [`modal-submit-button__submit--with-icon`]: this.withIcon,
        [`base-btn--disabled`]: this.disabled,
      };
    },
  },
  methods: {
    /**
     * @param {MouseEvent} event
     */
    click(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-submit-button {
  $base-modal: '.base-modal';
  $breakpoint: $breakpoint-m;
  $margin-sides-desktop: 80px;
  $margin-sides-mobile: 10px;

  &__submit-wrapper {
    display: flex;
    justify-content: center;
  }

  &__submit {
    &--with-icon {
      &::after {
        @extend %icon--arrow-right;
      }
    }
  }
}
</style>
